import React from 'react'

function Notfound() {
  return (
    <div>OOPs, page not found!!</div>
  )
}

export default Notfound